import { render, staticRenderFns } from "./cohort-consent-association.vue?vue&type=template&id=1ed67cf4&scoped=true&"
import script from "./cohort-consent-association.vue?vue&type=script&lang=js&"
export * from "./cohort-consent-association.vue?vue&type=script&lang=js&"
import style0 from "./cohort-consent-association.vue?vue&type=style&index=0&id=1ed67cf4&scoped=true&lang=scss&"
import style1 from "./styles/add-edit-multi-consent.scss?vue&type=style&index=1&id=1ed67cf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed67cf4",
  null
  
)

component.options.__file = "cohort-consent-association.vue"
export default component.exports